module.exports = __webpack_public_path__ + "img/certificate2-03.68294545.png";